function HomePropertyTypesSection({ propertyTypes }) {
  return (
    <section className="mx-auto w-[min(1120px,calc(100%-40px))] py-7" id="eiendomstyper">
      <div className="mb-6 max-w-[760px]">
        <p className="mb-3.5 text-xs uppercase tracking-[0.16em] text-[#7c6b52]">Eiendomstyper</p>
        <h2 className="font-serif text-[clamp(2rem,4vw,3.2rem)] font-semibold leading-[1.02] text-[#163127]">
          Vi leier ut ulike typer boliger og bygg.
        </h2>
      </div>
      <div className="grid gap-5 md:grid-cols-3">
        {propertyTypes.map((propertyType) => (
          <article
            className="rounded-[28px] border border-[#1832281a] bg-[rgba(249,245,238,0.88)] p-6 shadow-[0_22px_60px_rgba(24,50,40,0.08)]"
            key={propertyType.title}
          >
            <h3 className="mb-3.5 text-[1.45rem] text-[#163127]">{propertyType.title}</h3>
            <p className="text-[1.05rem] leading-[1.7] text-[#355046]">{propertyType.description}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default HomePropertyTypesSection;